<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_13"></a><a id="part01"></a>Part I</h2>
<h2 class="h2a">F<span class="small">EMINISM AND THE</span> I<span class="small">DEA AND</span> C<span class="small">ONSTRAINTS OF</span> F<span class="small">REEDOM</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?d60a4602